// src/components/OpenLabelModal.js
import React, { useState } from 'react';
import { ProductLabel, ScrewPicker } from './ProductLabel';

export const OpenLabelModal = ({ product, onClose, needsScrew = false, screwOptions = [] }) => {
  const [screwId, setScrewId] = useState(() =>
    screwOptions.length > 0 ? String(screwOptions[0].product_Id) : ''
  );
  const selectedScrew = screwOptions.find((s) => String(s.product_Id) === screwId);
  const screwSku = needsScrew && selectedScrew ? selectedScrew.SKU : '';

  const handlePrint = () => {
    const label = document.getElementById("print-label").innerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Label</title>
          <style>
            @page { size: 40mm 20mm; margin: 0; }
            body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background-color: white; }
            #print-label { width: 40mm; height: 20mm; text-align: center; padding: 10px; }
          </style>
        </head>
        <body>
          <div id="print-label">${label}</div>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ✅ Helper to prevent closing when clicking inside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0, 0, 0, 0.4)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}
      onClick={handleOverlayClick}
    >
      <div
        style={{ width: "100%", maxWidth: "500px", height: "100%", maxHeight: "500px", backgroundColor: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: "8px", padding: "10px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <ProductLabel product={product} type="open" screwSku={screwSku} />

        <ScrewPicker
          product={product}
          needsScrew={needsScrew}
          screwOptions={screwOptions}
          value={screwId}
          onChange={setScrewId}
        />

        <button
          onClick={handlePrint}
          style={{ marginTop: "10px", padding: "8px 12px", fontSize: "14px", fontWeight: "bold", color: "white", backgroundColor: "#007BFF", border: "none", borderRadius: "5px", cursor: "pointer", width: "100%", maxWidth: "150px", textAlign: "center" }}
        >
          Print Label
        </button>
      </div>
    </div>
  );
};